import { useContext } from "react";
import { useDispatch, useSelector } from "react-redux";
import { LangContext } from "../../context/LangContext";
import { openLangSelector } from "../../redux";

import "./style.css"

import flag_fr from '../../assets/svg/flag_fr.svg'
import flag_en from '../../assets/svg/flag_en.svg'

function SelectLang() {
    const dispath = useDispatch();
    const { toggleLanguage, language } = useContext(LangContext);
    const isOpen = useSelector(state => state.options.selectLang);

    const select_lang = (lang) => {
        if (!isOpen) {
            dispath(openLangSelector(true));
            return
        }
        toggleLanguage(lang);
        dispath(openLangSelector(false));
    }

    return (
        <div className='lang_selector'>
            <div className={isOpen ? 'isOpen' : ''}>
                <button onClick={() => select_lang(language)}>
                    <i className="fas fa-chevron-down"></i>
                    <p>{language === 'fr' ? 'Français' : 'English'}</p>
                    <img src={language === 'fr' ? flag_fr : flag_en} alt="" />
                </button>

                <button onClick={() => select_lang(language === 'fr' ? 'en' : 'fr')}>
                    <p>{language === 'fr' ? 'English' : 'Français'}</p>
                    <img src={language === 'fr' ? flag_en : flag_fr} alt="" />
                </button>
            </div>
        </div>
    )
}

export default SelectLang;